/**
 * Simple debounce utility.
 * @param {Function} fn     The function to debounce.
 * @param {number} delay    Delay in milliseconds.
 */
export const debounce = (fn, delay) => {
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => fn(...args), delay);
    };
};
